<template>
  <div :class="wrapClasses">
    <div :class="contentClasses">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Content',
  props: {
    closed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    wrapClasses () {
      return {
        'wrap': true,
        'wrap-closed': this.closed
      }
    },
    contentClasses () {
      return {
        'content': true,
        'content-closed': this.closed
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  max-height: 800px;
  overflow: hidden;
  transition: 1500ms cubic-bezier(.19,1,.22,1) all;
  will-change: max-height;
}

.content {
  padding: 0 1.5em 1.5em;
  opacity: 1;
  will-change: opacity, transform;
  transform: translateY(0px);
  transition: 1s cubic-bezier(.19,1,.22,1) all 0s;
}

.wrap-closed {
  max-height: 0;
  transition-duration: 0.5s;
}

.content-closed {
  opacity: 0;
  transform: translateY(8px);
}
</style>
